import { Model } from "@vuex-orm/core";

export default class UserPreferences extends Model {
  static entity = "userPreferences";

  static fields() {
    return {
      id: this.number(),
      calendarPreferences: this.attr().nullable(),
      telecomPreferences: this.attr().nullable(),
      reportPreferences: this.attr().nullable(),
      createdAt: this.attr(),
      updatedAt: this.attr()
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
